import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styled from 'react-emotion';
import { css } from 'emotion';

import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import OneMainImage from './OneMainImage';
import SliderMainImage from './SliderMainImage';
import DoubleSlickSlider from './DoubleSlickSlider';
import NavSliderImage from './NavSliderImage';
import ImageZoomPortalView from './ImageZoomPortalView';

const SliderContainer = styled.div`
  max-width: 400px;
  position: relative;
  div {
    z-index: 1;
  }
  .slick-slider {
    .slick-slide img {
      margin: auto;
    }
    .slick-dots {
      z-index: 1;
      ${props => props.media.maxMobile
        && css`
          bottom: 0;
        `};
      li {
        margin: 0;
        button:before {
          font-size: ${props => props.theme.fonts.sizes.xxxSmall}px;
          color: ${props => props.theme.colors.secondary};
        }
        &.slick-active button:before {
          font-size: ${props => props.theme.fonts.sizes.xSmall}px;
          color: ${props => props.theme.colors.secondary};
        }
      }
    }
  }
  ${props => props.media.tablet
    && css`
      max-width: 350px;
    `};
  ${props => props.media.xsmall
    && css`
      max-width: 300px;
    `};
`;

class ProductImageSlider extends Component {
  state = {
    renderPortalWrapper: false,
  }

  handlePortalStatus = (status) => {
    this.setState({ renderPortalWrapper: status });
  }

  render() {
    const { media, images } = this.props;
    const { renderPortalWrapper } = this.state;
    return (
      <React.Fragment>
        {images && (
          <SliderContainer
            media={media}
          >
            {images.length === 1 && <OneMainImage portalStatus={this.handlePortalStatus} smallImage={images[0][0]} largeImage={images[0][1]} />}
            {images.length > 1 && (
              <React.Fragment>
                <DoubleSlickSlider
                  childrenCount={images.length}
                  hideNavSlider={!media.minDesktop}
                  mainSliderChildren={
                    images.map(image => (
                      <SliderMainImage
                        smallImage={image[0]}
                        largeImage={image[1]}
                        alt={image[2]}
                        key={image[0]}
                        portalStatus={this.handlePortalStatus}
                      />
                    ))
                  }
                  navSliderChildren={
                    images.map(image => (
                      <NavSliderImage
                        key={image[0]}
                        image={image[0]}
                        alt={image[2]}
                      />
                    ))
                  }
                />
              </React.Fragment>
            )}
            <ImageZoomPortalView className={renderPortalWrapper ? 'active' : null} />
          </SliderContainer>
        )}
      </React.Fragment>
    );
  }
}

ProductImageSlider.propTypes = {
  images: PropTypes.arrayOf(PropTypes.any).isRequired,
  media: PropTypes.shape({}).isRequired,
};

export default withMedia(ProductImageSlider);
